import React, { useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { api } from "utils";
import { toast } from "react-toastify";
import { API_ENDPOINTS } from "utils";
import { handleError } from "utils/handleError";
import Translation from "components/common/translations";
import AuthController from "controllers/authController";
import flashStationimage from "assets/images/flashStationimage.jpg";
import flashIcon from "assets/images/FlashIcon.png";
import FooterLogin from "components/common/footerLogin";
import TranslationDropdown from "components/common/TranslationDropdown";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const navigateLoginPage = () => navigate("/login");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username) {
      toast.error(<Translation label="_enterEmail" />);
      return;
    }

    try {
      const body = { username };
      await api.post(API_ENDPOINTS.PASSWORD_RESET, body);
      toast.success(<Translation label="_passwordResetLinkSent" />);
      AuthController.localLogout();
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="logo">
          <img
            src={flashIcon}
            alt="Flash Logo"
            className="flash-logo"
            onClick={navigateLoginPage}
          />
          <TranslationDropdown />
        </div>
        <form onSubmit={handleSubmit}>
          <h1 className="h1-forgotPass">
            <Translation label="_forgotPassword" />
          </h1>
          <p className="p-description-forgotPass">
            <Translation label="_receiveCodeResetPass" />
          </p>
          <div className="input-container">
            <label htmlFor="username">
              <Translation label={"_enterYourEmail"} />{" "}
              <span style={{ color: "#883c84" }}>*</span>
            </label>
            <input
              type="email"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-button-forgotPass">
            <Translation label="_sendResetLink" />
          </button>
        </form>
      </div>

      <div className="login-image">
        <img src={flashStationimage} alt="Flash Station" />
      </div>
      <FooterLogin />
    </div>
  );
}
